var _rect, _mask, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBringForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.857143,
    y: 11.1428,
    width: 12,
    height: 12,
    rx: 1.71429,
    stroke: "black",
    strokeWidth: 1.71429
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_83_119",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 6.85693C4.57986 6.85693 3.42859 8.0082 3.42859 9.42836V10.2855H11.1429C12.563 10.2855 13.7143 11.4368 13.7143 12.8569V20.5712H14.5714C15.9916 20.5712 17.1429 19.42 17.1429 17.9998V9.42836C17.1429 8.0082 15.9916 6.85693 14.5714 6.85693H6.00002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 6.85693C4.57986 6.85693 3.42859 8.0082 3.42859 9.42836V10.2855H11.1429C12.563 10.2855 13.7143 11.4368 13.7143 12.8569V20.5712H14.5714C15.9916 20.5712 17.1429 19.42 17.1429 17.9998V9.42836C17.1429 8.0082 15.9916 6.85693 14.5714 6.85693H6.00002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42859 10.2855H1.7143V11.9998H3.42859V10.2855ZM13.7143 20.5712H12V22.2855H13.7143V20.5712ZM5.14287 9.42836C5.14287 8.95498 5.52663 8.57122 6.00002 8.57122V5.14265C3.63308 5.14265 1.7143 7.06142 1.7143 9.42836H5.14287ZM5.14287 10.2855V9.42836H1.7143V10.2855H5.14287ZM3.42859 11.9998H11.1429V8.57122H3.42859V11.9998ZM11.1429 11.9998C11.6163 11.9998 12 12.3835 12 12.8569H15.4286C15.4286 10.49 13.5098 8.57122 11.1429 8.57122V11.9998ZM12 12.8569V20.5712H15.4286V12.8569H12ZM14.5714 18.8569H13.7143V22.2855H14.5714V18.8569ZM15.4286 17.9998C15.4286 18.4732 15.0448 18.8569 14.5714 18.8569V22.2855C16.9384 22.2855 18.8572 20.3667 18.8572 17.9998H15.4286ZM15.4286 9.42836V17.9998H18.8572V9.42836H15.4286ZM14.5714 8.57122C15.0448 8.57122 15.4286 8.95497 15.4286 9.42836H18.8572C18.8572 7.06143 16.9384 5.14265 14.5714 5.14265V8.57122ZM6.00002 8.57122H14.5714V5.14265H6.00002V8.57122Z",
    fill: "black",
    mask: "url(#path-2-inside-1_83_119)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42861 5.143H18C18.4734 5.143 18.8572 5.52675 18.8572 6.00014V14.5716C18.8572 15.045 18.4734 15.4287 18 15.4287H17.1429V17.143H18C19.4202 17.143 20.5715 15.9917 20.5715 14.5716V6.00014C20.5715 4.57998 19.4202 3.42871 18 3.42871H9.42861C8.00845 3.42871 6.85718 4.57998 6.85718 6.00014V6.85728H8.57146V6.00014C8.57146 5.52675 8.95522 5.143 9.42861 5.143Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8572 1.71429H21.4286C21.902 1.71429 22.2858 2.09804 22.2858 2.57143V11.1429C22.2858 11.6162 21.902 12 21.4286 12H20.5715V13.7143H21.4286C22.8488 13.7143 24.0001 12.563 24.0001 11.1429V2.57143C24.0001 1.15127 22.8488 0 21.4286 0H12.8572C11.437 0 10.2858 1.15127 10.2858 2.57143V3.42857H12.0001V2.57143C12.0001 2.09804 12.3838 1.71429 12.8572 1.71429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringForward);
export default __webpack_public_path__ + "static/media/bringForward.c53d2e5381264471d99dc5433e4624db.svg";
export { ForwardRef as ReactComponent };